import CardLayout from '../../common/CardLayout';
import TitleCardSimple from '../../common/TitleCardSimple';
import CardPeriodoMedido from './CardPeriodoMedido';

import ChartAreaDefault from './charts/ChartAreaDefault';

const DemandaAtivaDiario = ({ dados, dadosDetalhado }) => {
	const valores = dados.map((elemento) => elemento.demandaAtiva);

	const horas = dados.map((elemento) => {
		const horaFormatada = new Date(elemento.dataHora);

		const horaString = horaFormatada.toLocaleTimeString([], {
			hour: '2-digit',
			hour12: false,
			minute: '2-digit',
		});
		return `${horaString}`;
	});

	const DemandaAtivaData = {
		date: horas,
		valor: valores,
	};

	return (
		<>
			<CardLayout>
				<div className="flex justify-center h-full flex-col items-center px-4">
					<TitleCardSimple>
						Demanda ativa{' '}
					</TitleCardSimple>
					{/* <div className="flex justify-center items-center">
						<CardPeriodoMedido
							ponta={dadosDetalhado?.ponta?.toLocaleString(
								'pt-BR',
								{
									maximumFractionDigits: 2,
								}
							)}
							FPCapacitivo={dadosDetalhado?.foraPontaCapacitivo?.toLocaleString(
								'pt-BR',
								{
									maximumFractionDigits: 2,
								}
							)}
							FPIndutivo={dadosDetalhado?.foraPontaIndutivo?.toLocaleString(
								'pt-BR',
								{
									maximumFractionDigits: 2,
								}
							)}
							dateFPCapacitivo={
								dadosDetalhado?.data
							}
							dateFPIndutivo={dadosDetalhado?.data}
							datePonta={dadosDetalhado?.data}
							unidade={'kW'}
						/>
					</div> */}
					<ChartAreaDefault
						typeChart="demandaAtiva"
						nameSerie="Demanda Ativa ( kW )"
						chartDataProps={DemandaAtivaData}
					/>
				</div>
			</CardLayout>
		</>
	);
};

export default DemandaAtivaDiario;
